import React from "react";
import AdminModulePage from "../../../components/Admin/ModulePage/AdminModulePage";

const CashManagement = () => {
    return <AdminModulePage moduleKey="cash-management" />;
};

export default CashManagement;
